import axiosInstance from 'utils/axiosUtil';

export async function speakWithOpenAI(text) {
  /* always ask for binary – Express will honour it, API-GW will not */
  const resp = await axiosInstance.post(
    '/AI',
    { type: 'tts-preview', text, voice: 'alloy' },
    { responseType: 'arraybuffer' }  
  );

  let bytes;

  /*  Express dev server → resp.data is already an ArrayBuffer */
  if (resp.data instanceof ArrayBuffer) {
    bytes = new Uint8Array(resp.data);

  /*   API-Gateway → resp.data is a UTF-8-encoded base-64 string */
  } else if (typeof resp.data === 'string') {
    const bin   = atob(resp.data.replace(/\s/g, ''));   // strip white-space
    bytes       = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);

  } else {
    console.error('Unrecognised TTS payload', resp.data);
    return;
  }

  /* play */
  const blob  = new Blob([bytes.buffer], { type: 'audio/mpeg' });
  new Audio(URL.createObjectURL(blob)).play();
}

/*
export async function speakWithOpenAI(text) {
  const resp = await axiosInstance.post(
    '/AI',
    { type: 'tts-preview', text, voice: 'alloy' },
    { responseType: 'arraybuffer' }          // ← returns raw bytes
  );

  const blob = new Blob([resp.data], { type: 'audio/mpeg' });
  const url  = URL.createObjectURL(blob);
  new Audio(url).play();
}
*/